function loadImage(src: string) {
  return new Promise<HTMLImageElement>((resolve, reject) => {
    const img = new Image()
    img.onload = () => resolve(img)
    img.onerror = reject
    img.crossOrigin = "anonymous"
    img.src = src
  })
}

export async function generateImagePlaceholder(imageUrl: string, type = "image/png", quality = 1, height = 7) {
  const img = await loadImage(imageUrl)
  const aspectRatio = img.width / img.height
  const width = height * aspectRatio

  if (!window) {
    throw new Error("Image resizing does not work serverside")
  }

  const canvas = document.createElement("canvas")
  const ctx = canvas.getContext("2d")

  if (!ctx) {
    throw new Error("Failed to create canvas for image resizing")
  }
  canvas.width = width
  canvas.height = height
  ctx.imageSmoothingEnabled = true
  ctx.imageSmoothingQuality = "high"
  ctx.drawImage(img, 0, 0, width, height)

  const dataurl = canvas.toDataURL(type, quality)
  const base64data = dataurl.match(/^data:image\/[^;]*;base64,(.*)$/)?.[1]
  if (!base64data) {
    throw new Error("Resized image data url does not look like a data url")
  }

  return {
    blur: base64data,
    aspectRatio: aspectRatio,
  }
}
